export const commissionPayout = {
  commissionPayout: "Commission Payout",
  search: "Search",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  mobileNumber: "Mobile Number",
  dateRequested: "Date Requested",
  cancel: "Cancel",
  filter: "Filter",
  accountName: "ACCOUNT NAME",
  phoneNumber: "PHONE NUMBER",
  amount: "AMOUNT",
  requested: "REQUESTED DATE",
  startDate: "START DATE",
  endDate: "END DATE",
  status: "STATUS",
  paid: "Paid",
};
